import { Button, Input } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { Fragment, useState } from 'react';
import { getCouponPrice } from './functions';
import { checkCoupon } from '../../API/CouponService';
import { formatMoney } from '../../Helpers/formatters';

function Coupon({ basePrice, onSuccess }) {
  const [error, setError] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [addedCoupon, setAddedCoupon] = useState(undefined);
  const validateCoupon = async () => {
    try {
      setIsLoading(true);
      setError(undefined);
      const result = await checkCoupon(couponCode);
      setAddedCoupon(result);
      onSuccess(result);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        border: 'solid 1px #D6D6D6',
        padding: '16px 16px',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        margin: '16px 0px',
      }}
    >
      <div
        style={{
          fontSize: '16px',
          fontWeight: 600,
          marginBottom: '16px',
        }}
      >
        Coupon Code
      </div>
      {addedCoupon && (
        <div
          style={{
            textAlign: 'center',
            marginTop: '24px',
            marginBottom: '20px',
          }}
        >
          <div
            style={{
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '8px',
            }}
          >
            Success! You've applied the {addedCoupon?.coupon?.name} coupon
          </div>
          <div>
            Your first month's payment will be reduced by{' '}
            {formatMoney(basePrice - getCouponPrice(addedCoupon, basePrice))}{' '}
            for a total charge of{' '}
            {formatMoney(getCouponPrice(addedCoupon, basePrice))}.
          </div>
        </div>
      )}

      {!addedCoupon && (
        <Fragment>
          <div style={{ marginBottom: '8px' }}>
            <Input
              placeholder="Enter coupon code"
              onChange={(e) => setCouponCode(e.target.value)}
            />
          </div>
        </Fragment>
      )}
      {error && (
        <div style={{ marginBottom: '8px', color: '#ff4d4f' }}>
          The coupon code you entered does not exist
        </div>
      )}

      {!addedCoupon && (
        <Content style={{ textAlign: 'right', marginTop: '20px' }}>
          <Button
            htmlType="submit"
            size="large"
            style={{ width: '100%' }}
            type={'primary'}
            loading={isLoading}
            onClick={validateCoupon}
          >
            Apply Coupon
          </Button>
        </Content>
      )}
    </div>
  );
}

export default Coupon;
